const sidebartoggler = document.getElementById('sidebartoggler');
const sidebardrawer = document.getElementById('sidebardrawer');

sidebartoggler.addEventListener("click", function() {
    this.classList.toggle('open');
    sidebardrawer.classList.toggle('open');
});

document.addEventListener('DOMContentLoaded', function(){
    const options = {
        rootMargin: '-100px 40px',
    };
    function callback(entries){
        Array.prototype.forEach.call(entries, function(entry){
            if (entry.isIntersecting) {
                entry.target.classList.add('scrollin');
                observer.unobserve(entry.target);
            }
        });
    }
    const observer = new IntersectionObserver(callback,options);
    const fadeins = document.querySelectorAll('.fadein,.fadeint,.fadeinr,.fadeinl,.fadeinb,.fadeino,.ef');
    Array.prototype.forEach.call(fadeins, function(fadein){
        observer.observe(fadein);
    });
});

$('a[href*="#"]:not(.noscroll)').click(function(){
    var speed = 500;
    var href= $(this).attr('href').split("#").slice(-1);
    var target = $(href == "#" || href == "" ? 'html' : '#'+href);
    var position = target.offset().top;
    $("html, body").animate({
        scrollTop:position
    }, speed, "swing");

    $('#sidebartoggler').removeClass('open');
    $('#sidebardrawer').removeClass('open');
    return false;
});